/****************************************************
 * Module Name:  AddTenderModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import { Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import "bootstrap/dist/css/bootstrap.min.css";
import { Box, Button, TextField } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import logo from '../../../images/pansuriya.jpg'
import SaveIcon from '@mui/icons-material/Save';
import Constants from "../../../utility/constants";
import CommonSnackbar from "../../common/commonSnackBar";
import TenderCompanyProxy from "../../../utility/proxy/manager/manufacturingProxy/tenderCompanyProxy";
import Select from "react-select";
import { DatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import dayjs from "dayjs";

export default class AddTenderModal extends Component {
    constructor(props) {
        super(props);

        const parseTenderMonth = (tenderMonthString) => {
            if (!tenderMonthString) return new Date();
            const [month, year] = tenderMonthString.split("-");
            const monthIndex = new Date(`${month} 1, 2000`).getMonth();
            return new Date(year, monthIndex, 1);
        };

        this.state = {
            newtendername: this.props.editOperation
                ? this.props.sourceData.tendername
                : "",

            newtendermonth: this.props.editOperation
                ? parseTenderMonth(this.props.sourceData.tendermonth)
                : new Date(),

            newtenderfrom: this.props.editOperation
                ? this.props.sourceData.tenderfrom
                : "",

            newtenderto: this.props.editOperation
                ? this.props.sourceData.tenderto
                : "",

            companyData: {
                company: this.props.sourceData.companyid || "",
                companyOptions: [],
            },

            showError: false,
            showValidationMessage: false,
            validateCompanyNamePresentSpinner: false,
            companyNameAvailable: true,

            nameValidationError: "",

            warning: false,
            warningmessage: "",

            error: false,
            errorMessage: "",
        };
    }

    componentDidMount() {
        this.getCompanyData();
    }

    getCompanyData = () => {
        TenderCompanyProxy.GetCompanyMini((response) => {
            this.setCompanyOptions(response);
        });
    };

    setCompanyOptions = (response) => {
        let optionsArray = [];
        response.map((data) => {
            let option = { value: data.id, label: data.id + " | " + data.name };
            optionsArray.push(option);
            return true;
        });

        const selectedCompany = optionsArray.find(
            (option) => option.value === this.props.sourceData.companyid
        );
        this.setState({
            companyData: {
                ...this.state.companyData,
                companyOptions: optionsArray,
                company: selectedCompany || optionsArray[0],
            },
        });
    }

    closeErrorDialog = () => {
        this.setState({
            showError: false,
        });
    };

    handleSave = () => {
        let data = {
            id: this.props.editOperation ? this.props.sourceData.id : undefined,
            tendername: this.state.newtendername ? this.state.newtendername : null,
            companyid: this.state.companyData.company.value,
            tendermonth: this.state.newtendermonth ? dayjs(this.state.newtendermonth).format('MMM-YYYY') : null,
            tenderfrom: (this.state.newtenderfrom !== null && this.state.newtenderfrom !== "") ?
                dayjs(this.state.newtenderfrom).format('YYYY-MM-DD') + "T00:00:00.000Z" : null,
            tenderto: (this.state.newtenderto !== null && this.state.newtenderto !== "") ?
                dayjs(this.state.newtenderto).format('YYYY-MM-DD') + "T23:59:59.999Z" : null,
        };

        if (this.props.handleSave) {
            if (this.props.handleValidation) {
                if (this.props.handleValidation(data))
                    this.props.handleSave(data);
                else
                    this.setState({
                        showError: true,
                    });
            } else
                this.props.handleSave(data);
        }
    };

    buttonDisable = () => {
        const hasValidationErrors =
            !this.state.companyData.company ||
            !this.state.newtendermonth ||
            !this.state.newtenderfrom ||
            !this.state.newtenderto

        return hasValidationErrors;
    };

    render() {
        return (
            <Box>
                <CommonSnackbar
                    show={this.state.showError}
                    message={
                        <Box>
                            Add tender validation Failed
                            <br /> Please enter complete data
                        </Box>
                    }
                    variant={"error"}
                    autoHide={false}
                    handleClose={this.closeErrorDialog}
                    title="Validation Failure"
                />

                <CommonSnackbar
                    show={this.state.warning}
                    message={this.state.warningmessage}
                    variant={"warning"}
                    autoHide={Constants.SnackBarCloseTimer}
                    title={"Warning"}
                    handleClose={() => {
                        this.setState({
                            warning: false,
                            warningmessage: ""
                        })
                    }}
                />

                <Modal backdrop="static" show={this.props.Show} onHide={this.props.handleClose} enforceFocus={false}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <img
                                src={logo}
                                height="40pt"
                                width="40pt"
                                alt={Constants.COMPANY_SITE}
                            />
                            &nbsp;&nbsp;
                            {this.props.editOperation ? "Edit Tender" : "Add New Tender"}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <center>
                            <table style={{ width: "100%" }}>
                                <tr>
                                    <td>
                                        <Form.Label>
                                            Tender Name
                                        </Form.Label>
                                    </td>
                                    <td>
                                        <TextField
                                            margin="normal"
                                            fullWidth
                                            size="small"
                                            label="Tender Name"
                                            placeholder="Enter Tender Name"
                                            value={this.state.newtendername}
                                            onChange={(e) =>
                                                this.setState({
                                                    newtendername: e.target.value,
                                                })
                                            }
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                </tr>
                                <tr>
                                    <td>
                                        <Form.Label>
                                            Company <sup style={{ color: "red" }}>*</sup>
                                        </Form.Label>
                                    </td>
                                    <td>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                gap: "20px",
                                                width: "100%",
                                            }}
                                        >
                                            <Box style={{ width: "100%" }}>
                                                <Select menuPlacement="auto"
                                                    blurInputOnSelect={false}
                                                    className="basic-single"
                                                    classNamePrefix="select"
                                                    value={this.state.companyData.companyOptions.find(
                                                        (iCompany) =>
                                                            iCompany.value === this.state.companyData.company.value
                                                    )}
                                                    isSearchable={true}
                                                    name="Company"
                                                    menuPortalTarget={document.body}
                                                    styles={Constants.Styles}
                                                    options={this.state.companyData.companyOptions}
                                                    onChange={(selectedOption) => {
                                                        this.setState({
                                                            companyData: {
                                                                ...this.state.companyData,
                                                                company: selectedOption,
                                                            },
                                                        })
                                                    }}
                                                />
                                            </Box>
                                        </Box>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                </tr>
                                <tr>
                                    <td>
                                        <Form.Label>
                                            Tender Month <sup style={{ color: "red" }}>*</sup>
                                        </Form.Label>
                                    </td>
                                    <td>
                                        <div style={{ width: '100%', maxWidth: '350px', marginBottom: '10px' }}>
                                            <LocalizationProvider dateAdapter={AdapterDateFns} >
                                                <DatePicker
                                                    views={['year', 'month']}
                                                    label="Tender Month"
                                                    value={this.state.newtendermonth}
                                                    onChange={(date) => this.setState({ newtendermonth: date })}
                                                    renderInput={(params) => <TextField {...params} fullWidth size="small" />}
                                                />
                                            </LocalizationProvider>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                </tr>
                                <tr>
                                    <td>
                                        <Form.Label>Tender From <sup style={{ color: "red" }}>*</sup></Form.Label>
                                    </td>
                                    <td>
                                        <div style={{ width: '100%', maxWidth: '350px' }}>
                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                <DatePicker
                                                    label="Tender From"
                                                    value={this.state.newtenderfrom}
                                                    onChange={(newValue) => {
                                                        if (newValue) {
                                                            this.setState({ newtenderfrom: newValue });
                                                        }
                                                    }}
                                                    inputFormat="dd/MM/yyyy"
                                                    renderInput={(params) => <TextField {...params} fullWidth size="small" />}
                                                />
                                            </LocalizationProvider>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                </tr>
                                <tr>
                                    <td>
                                        <Form.Label>
                                            Tender To <sup style={{ color: "red" }}>*</sup>
                                        </Form.Label>
                                    </td>
                                    <td>
                                        <div style={{ width: '100%', maxWidth: '350px' }}>
                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                <DatePicker
                                                    label="Tender To"
                                                    value={this.state.newtenderto}
                                                    onChange={(newValue) => {
                                                        if (newValue) {
                                                            this.setState({ newtenderto: newValue });
                                                        }
                                                    }}
                                                    inputFormat="dd/MM/yyyy"
                                                    renderInput={(params) => <TextField {...params} fullWidth size="small" />}
                                                />
                                            </LocalizationProvider>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </center>
                    </Modal.Body>
                    <Modal.Footer>
                        <LoadingButton
                            loading={this.props.loading}
                            loadingPosition="start"
                            startIcon={<SaveIcon />}
                            variant="contained"
                            onClick={() => this.handleSave()}
                            disabled={this.buttonDisable()}
                            sx={{ mr: 1 }}
                        >
                            Save
                        </LoadingButton>
                        <Button
                            variant="contained"
                            color="error"
                            onClick={this.props.handleClose}
                            disabled={this.props.loading}
                        >
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            </Box>
        )
    }
}